import { Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IFormInputSpec } from 'pages/revisions-module/template-editor/editors/form/types';
import { useMemo } from 'react';
import { useFormSections } from 'pages/revisions-module/template-editor/editors/form/section/FormSectionsDataProvider';

/**
 * Sub-form for number input properties
 */
export default function NumberOfMeasurementsInputPropertiesSubForm({
  form,
}: {
  form: UseFormReturnType<IFormInputSpec>;
}) {
  const { sections } = useFormSections();

  const options = useMemo(
    () => sections.filter(({ tab }) => tab === 'measurements').map(({ id, name }) => ({ value: id, label: name })),
    [sections]
  );

  return <Select required size="sm" label="Tabuľka meraní" data={options} {...form.getInputProps('sectionId')} />;
}
